<template>
  <section>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="unidades" label="Associar Unidades" />
      <q-tab name="centros" label="Centros de Custo" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="centros">
        <table-centros />
      </q-tab-panel>

      <q-tab-panel name="unidades">
        <table-unidades />
      </q-tab-panel>
    </q-tab-panels>
  </section>
</template>

<script>
import { ref } from "@vue/reactivity";
import TableCentros from "./TableCentros.vue";
import TableUnidades from "./TableUnidades.vue";
export default {
  components: {
    TableCentros,
    TableUnidades,
  },
  setup() {
    const tab = ref("unidades");
    return {
      tab,
    };
  },
};
</script>

<style></style>
